/**
 * @generated SignedSource<<4c3e5f35008822360c341c0dae11bf63>>
 * @relayHash cdf0eecec7801ada9428ad1b337ae89e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcf0b0412281be529a8664d5a376c9740e37e90202a28c6ba7bdc1dda8aed665

import type { ConcreteRequest } from 'relay-runtime';
export type useAccessRequestSettingsQuery$variables = {
  cloudId: string;
};
export type useAccessRequestSettingsQuery$data = {
  readonly confluence: {
    readonly siteConfiguration: {
      readonly contentAccessRequestSettings: {
        readonly enabled: boolean | null;
        readonly messageContent: string | null;
      } | null;
      readonly spaceAccessRequestSettings: {
        readonly enabled: boolean | null;
        readonly messageContent: string | null;
      } | null;
    } | null;
  } | null;
};
export type useAccessRequestSettingsQuery = {
  response: useAccessRequestSettingsQuery$data;
  variables: useAccessRequestSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "enabled"
  },
  {
    "kind": "ScalarField",
    "name": "messageContent"
  }
],
v2 = [
  {
    "concreteType": "ConfluenceQueryApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "ConfluenceSiteConfiguration",
        "kind": "LinkedField",
        "name": "siteConfiguration",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceAccessRequestSettings",
            "kind": "LinkedField",
            "name": "contentAccessRequestSettings",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          {
            "concreteType": "ConfluenceAccessRequestSettings",
            "kind": "LinkedField",
            "name": "spaceAccessRequestSettings",
            "plural": false,
            "selections": (v1/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessRequestSettingsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessRequestSettingsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cdf0eecec7801ada9428ad1b337ae89e",
    "id": "dcf0b0412281be529a8664d5a376c9740e37e90202a28c6ba7bdc1dda8aed665",
    "metadata": {},
    "name": "useAccessRequestSettingsQuery",
    "operationKind": "query",
    "text": "query useAccessRequestSettingsQuery($cloudId:ID!){confluence{siteConfiguration(cloudId:$cloudId){contentAccessRequestSettings{enabled,messageContent},spaceAccessRequestSettings{enabled,messageContent}}}}"
  }
};
})();

(node as any).hash = "9251c72a797923036753a27ae77f8222";

export default node;
